import React from 'react';
import { _cs } from '@togglecorp/fujs';
import styles from './styles.css.js';

function SwitchIcon(props) {
  const {
    className,
    value
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: _cs(styles.switchIcon, className, value ? styles.on : styles.off)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.knob
  }));
}

export { SwitchIcon as default };
//# sourceMappingURL=index.js.map
